import { LoadingSpinner } from "@xapp/components";
import { login, signUp } from "auth/modules/actions";
import { CodeChallenge, useGetCodeChallengeMutation } from "generated/graphql";
import React, { FC, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { RouteComponentProps } from "react-router-dom";
import { useWrapUrql } from "utils/graphql/useWrapUrql";
import { getValueOfKey } from "utils/String";

export interface LoginState {
    from?: {
        pathname: string;
        search: string;
    }
}

export interface LoginProps extends RouteComponentProps<Record<string, never>, any, LoginState> { }

export function getLogin(mode: "login" | "signup"): FC<LoginProps> {

    return props => {
        const dispatch = useDispatch();
        const { location } = props;
        const { state } = location;

        const [codeChallenge, setCodeChallenge] = useState<CodeChallenge>();

        const getCodeChallenge = useWrapUrql(useGetCodeChallengeMutation(), {
            onSuccessMessage: false
        });

        useEffect(() => {
            if (codeChallenge) {
                const { from } = state || { from: { pathname: "/", search: "" } };
                const moveTo = from.pathname + from.search;
                const awsId = getValueOfKey("awsId", from.search)[0];
                const action =
                    mode === "login"
                        ? login({
                            awsId,
                            codeChallenge,
                            moveTo
                        })
                        : signUp({
                            awsId,
                            codeChallenge,
                            moveTo
                        });
                dispatch(action);
            } else {
                getCodeChallenge().then(codeChallengeResponse => {
                    setCodeChallenge(codeChallengeResponse.data?.codeChallenge);
                });
            }
        }, [codeChallenge, state, dispatch, getCodeChallenge]);

        const loadingText: string = mode === "login" ? "Redirecting to login..." : "Redirecting to sign-up...";

        return <LoadingSpinner loadingText={loadingText} />;
    };
}
